<template>
  <section>
    <section class="typeBox">
      <el-radio-group v-model="radio" @input="searchFormChange">
        <el-radio-button label="按日期"></el-radio-button>
        <el-radio-button label="按车辆"></el-radio-button>
      </el-radio-group>
    </section>
    <section v-if="radio==='按日期'">
      <qx-search-box
          class="searchBox"
          :searchBoxData="searchBoxData"
          ref="searchBox"
          @sub="sub"
          @reset="reset"
          :title="vehicleType===1?'燃油车-日油耗统计':'燃气车-日气耗统计'"
          :moreSearchVisible="true"
          permpisionsQuery=""
      >
      </qx-search-box>

    </section>
    <section v-if="radio==='按车辆'">
      <qx-search-box
          class="searchBox"
          :searchBoxData="searchBoxData"
          ref="searchBox"
          @sub="sub"
          @reset="reset"
          :title="vehicleType===1?'燃油车-车辆油耗统计':'燃气车-车辆气耗统计'"
          :moreSearchVisible="true"
          permpisionsQuery=""
      >
      </qx-search-box>
    </section>
    <ByDateTableBox ref="byDateTableBox" :vehicleType="vehicleType" v-if="radio==='按日期'"   @jumpVehicle="jumpVehicle"/>
    <ByVehicleTableBox ref="byVehicleTableBox" :vehicleType="vehicleType" v-if="radio==='按车辆'"/>
  </section>
</template>

<script>
import ByDateTableBox from './byDateTableBox';
import ByVehicleTableBox from './byVehicleTableBox';
import {dayOfTheMonth, formatDateTime, getLastMonthDay} from '@qx/utils';
import {getEnumList} from 'api';
export default {
  components: {
    ByDateTableBox,
    ByVehicleTableBox,
  },
  data () {
    return {
      searchPlateNumber: '', // 查询车牌号
      radio: '按日期',
      vehicleType: 1,
      childNode: false,
      nodeStatus: false,
      searchBoxData: {
        orderTypeOptions: [], // 排序方式
        form: [
          {
            label: '排序方式',
            value: 'orderType',
            type: 'select',
            default: '1',
            placeholder: '请选择排序方式',
          },
          {
            label: '车牌号',
            value: 'carNo',
            type: 'input',
            hide: true,
          },
          {
            label: '使用日期',
            value: 'Date',
            type: 'date',
            placeholder: '请选择日期',
            width: '260px',
            attr: {
              type: 'daterange',
              time: ['', ''],
            },
            pickerOptions: {
              disabledDate (time) {
                return time.getTime() > Date.now() - 24 * 3600 * 1000;

              },
            },

          },
        ],
      },
    };
  },
  watch: {
    radio: function (val) {
      this.searchPlateNumber = '';
      this.radioChange(val);
      if (!this.searchPlateNumber || !this.nodeStatus) {
        this.$nextTick(() => {
          this.$refs.searchBox.sub();
        });
      }
      this.$emit('setCurrentKey', val, this.vehicleType);
    },
    vehicleType: {
      immediate: true,
      async handler (val) {
        await this.getEnum();
        await this.radioChange(this.radio);
        if (!this.nodeStatus) {
          await this.$nextTick(() => {
            this.$refs.searchBox.sub();
          });
        }
      },
    },
    searchPlateNumber: {
      handler (val) {
        if (val) {
          this.nodeStatus = true;
          this.$nextTick(() => {
            this.$refs.searchBox.sub();
          });
        } else {
          this.nodeStatus = false;
        }
      },
    },
  },
  methods: {
    reset (val) {
      if (val === 'reset') {
        this.$refs.searchBox.setVal('orderType', this.searchBoxData.orderTypeOptions[0].value);
      }
    },
    setData (data, val) {
      const vehicleTypeMap = {
        '所有车辆': 1,
        '燃油车': 1,
        '燃气车': 2,
      };
      if (data && vehicleTypeMap[data.label]) {
        if (data.label === '所有车辆') {
          return;
        }
        this.vehicleType = vehicleTypeMap[data.label];
        this.searchPlateNumber = '';
        this.setSearchType(false);
      } else {
        this.vehicleType = vehicleTypeMap[val.parent.data.label];
        this.searchPlateNumber = data.label;
        this.setSearchType(true);
      }
    },
    setSearchType (flag) {
      this.radio = flag ? '按车辆' : '按日期';
      this.searchFormChange(this.radio);
    },

    searchFormChange (val) { // 控制搜索栏表单
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'hide',
        value: val !== '按车辆',
        names: ['carNo'],
      });
      this.$refs.searchBox.setVal('carNo', this.searchPlateNumber);
    },

    setDefalutDate () { // 设置“使用日期”的默认时间
      // 判断某天为本月第一天时，使用日期默认回填上个月整月的数据
      let date = dayOfTheMonth(new Date(), 1) ? [this.formatDate(getLastMonthDay(new Date(), 1, 1)), this.formatDate(getLastMonthDay(new Date(), null, 0))] : [this.formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)), this.formatDate(formatDateTime(new Date(), -1))];
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'default',
        value: date,
        names: ['Date'],
      });
    },

    radioChange (val) {
      if (val === '按车辆') {
        const index = this.searchBoxData.orderTypeOptions.findIndex((item) => item.label === '按日期降序');
        if (index !== -1) {
          this.searchBoxData.orderTypeOptions.splice(index, 1);
        }
      } else {
        const flag = this.searchBoxData.orderTypeOptions.findIndex((item) => item.label === '按日期降序');
        if (flag) {
          this.searchBoxData.orderTypeOptions.unshift({label: '按日期降序', value: '1'});
        }
      }
      this.$nextTick(() => {
        this.$refs.searchBox.setVal('orderType', this.searchBoxData.orderTypeOptions[0].value);
      });
    },

    jumpVehicle (item) {
      this.radio = '按车辆';
      this.$refs.searchBox.setVal('Date', [this.formatDate(item.createDate), this.formatDate(item.createDate)]);
      this.searchFormChange(this.radio, 'vehicledDetail');
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 使用时间
      if (searchBoxData.Date && searchBoxData.Date.length > 0) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Date[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Date[1]);
        delete searchBoxData.Date;
      }
      if (this.radio === '按日期') {
        this.$refs.byDateTableBox.saveSearchBoxData({
          queryType: this.vehicleType,
          ...searchBoxData,
        });
      } else {
        this.$refs.byVehicleTableBox.saveSearchBoxData({
          fuelType: this.vehicleType,
          ...searchBoxData,
        });
      }

    },
    async getEnum () {
      const enumsList = await getEnumList({
        codeType: 'FUEL_CAR_SORT_TYPE,GAS_CAR_SORT_TYPE',
      });
      this.searchBoxData.orderTypeOptions = this.vehicleType === 1 ? [
        ...enumsList[0],
      ] : [
        ...enumsList[1],
      ];
    },
  },
  created () {
    this.setDefalutDate();
  },
};
</script>

<style scoped lang="scss">
.typeBox{
  margin-bottom: 10px;
}

</style>
